module.exports = __webpack_public_path__ + "img/grey_028.cb0e0a77.png";